// extracted by mini-css-extract-plugin
module.exports = {"draftPurchaseOrders":"DraftPOsList_draftPurchaseOrders__2lhIZ","draftPurchaseOrders_withPOSore":"DraftPOsList_draftPurchaseOrders_withPOSore__Lj-SI"};